export const contacts = [
  {
    name: "Рязанов Роман Николаевич",
    role: "Директор компании\nАвтор обучающих программ",
    email: "RRyazanov@i-d-tech.com",
    phone: "+7 (922) 478-38-33",
  },
  {
    name: "Ястребов Илья Динарович",
    role: "Заместитель директора\nТехнический инструктор / Заведующий лабораторией",
    email: "IDYastrebov@i-d-tech.com",
    phone: "+7 (912) 927-62-55",
  },
  {
    name: "Билетников Егор Юрьевич",
    role: "Руководитель направления\n“Инженерное сопровождение”",
    email: "EYuBiletnikov@i-d-tech.com",
    phone: "+7 (922) 483-92-33",
  },
  {
    name: "Сулейманов Рамис Робертович",
    role: "Руководитель направления\n“Ремонтно-изоляционные работы”",
    email: "RRSuleimanov@i-d-tech.com",
    phone: "+7 (952) 677-51-02",
  },
  {
    name: "Мурашко Александр Евгеньевич",
    role: "Руководитель направления\n“Разработка программного обеспечения”",
    email: "AEMurashko@i-d-tech.com",
    phone: "+7 (904) 476-49-88",
  },
];
